import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFunctions } from '../hooks';
import DoyoBadge from '../components/DoyoBadge';

// Custom imports:
import { Group } from '../components';

export const Auth_fullscreenWrapper = ({ children }) => {
  const { t } = useTranslation();
  const { run } = useFunctions();
  
  // Custom consts:

  // Custom functions:

  return (
    <main id="Auth_fullscreenWrapper" className="view h-fill">
        
				<Group className="flex-grow-1">{children}</Group>
        <DoyoBadge />
    </main>
  );
};
